export default () => ({
  showAside: false,
  blueprint: 'A1+',

  show(blueprint) {
    this.blueprint = blueprint;
    this.showAside = true;
    document.body.classList.add("stop-scrolling");
  },

  hide() {
    this.showAside = false;
    document.body.classList.remove("stop-scrolling");
  },

});
